import React from 'react';
import { Box, Flex, Spinner, Text, useColorModeValue } from '@chakra-ui/react';
import { useTranslation } from 'i18n/TranslationProvider';

export default function LoadingScreen() {
  const { t } = useTranslation();
  
  const background = useColorModeValue(
    'linear(to-br, #f8fbff, #eef4ff 35%, #e9f0ff)',
    'linear(to-br, #0f1835, #161f45 45%, #1d2a56)'
  );
  const textColor = useColorModeValue('brand.600', 'white');
  const spinnerEmptyColor = useColorModeValue('gray.200', 'whiteAlpha.200');
  const glowOpacity1 = useColorModeValue(0.15, 0.35);
  const glowOpacity2 = useColorModeValue(0.1, 0.22);
  
  return (
    <Box position="relative" minH="100dvh" bgGradient={background} overflow="hidden">
      {/* Decorative Glow Elements */}
      <Box
        position="absolute"
        top="-220px"
        right="-220px"
        w="560px"
        h="560px"
        borderRadius="full"
        bgGradient="radial(brand.300, transparent 68%)"
        opacity={glowOpacity1}
        pointerEvents="none"
      />
      <Box
        position="absolute"
        bottom="-260px"
        left="-180px"
        w="520px"
        h="520px"
        borderRadius="full"
        bgGradient="radial(blue.300, transparent 70%)"
        opacity={glowOpacity2}
        pointerEvents="none"
      />

      {/* Loading Content */}
      <Flex
        position="absolute"
        inset={0}
        direction="column"
        align="center"
        justify="center"
        zIndex={1}
      >
        <Spinner 
          thickness="4px" 
          speed="0.65s" 
          emptyColor={spinnerEmptyColor}
          color="brand.400" 
          size="xl" 
          mb={5}
        />
        <Text 
          fontSize="lg" 
          fontWeight="600" 
          color={textColor} 
          letterSpacing="wide"
          animation="pulse 2s infinite"
          sx={{
            '@keyframes pulse': {
              '0%': { opacity: 1 },
              '50%': { opacity: 0.5 },
              '100%': { opacity: 1 },
            }
          }}
        >
          {t('Loading…')}
        </Text>
      </Flex>
    </Box>
  );
}
